import styled, { css } from "styled-components";

interface ModalContainerProps {
  isLoading: boolean;
}

export const ModalContainer = styled.div<ModalContainerProps>`
  display: flex;
  flex-direction: column;
  min-height: 20rem;

  ${(props) =>
    props.isLoading &&
    css`
      align-items: center;
      justify-content: center;
    `};
`;

export const OptionsAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 1rem;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;

  span {
    margin-top: 0.5rem;
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    max-height: 50vh;
    margin-top: 1rem;

    span {
      margin-top: 0;
    }
  }
`;

export const ResponsiveButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;

  button {
    height: 2.5rem;
    width: 100%;
  }
`;

export const ButtonAlign = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;

export const CheckBoxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
